<form [formGroup]="form" (ngSubmit)="onSubmit()" class="form">
  <kendo-formfield class="form-group form-group--full-width">
    <kendo-label text="Epic"></kendo-label>

    <kendo-dropdownlist
      [data]="filteredEpics"
      [filterable]="true"
      valueField="id"
      textField="summary"
      (filterChange)="onEpicFilter($event)"
      formControlName="epic">
    </kendo-dropdownlist>

    <kendo-formerror *ngIf="form.controls.epic.invalid">
      Epic is required
    </kendo-formerror>
  </kendo-formfield>

  <div class="form-row">
    <kendo-formfield class="form-group form-group--flex">
      <kendo-label text="Story Points"></kendo-label>

      <kendo-numerictextbox
        formControlName="storyPoints"
        [decimals]="0"
        format="n0">
      </kendo-numerictextbox>

      <kendo-formerror *ngIf="form.controls.storyPoints.invalid">
        Value must be between 1 and 100
      </kendo-formerror>
    </kendo-formfield>

    <kendo-formfield class="form-group form-group--flex">
      <kendo-label text="Priority"></kendo-label>

      <kendo-dropdownlist
        [data]="priorities"
        textField="name"
        valueField="id"
        formControlName="priority">

        <ng-template kendoDropDownListValueTemplate let-dataItem>
          <span
            class="priority-color-circle"
            [style.background-color]="dataItem?.statusColor">
          </span>
          <span class="priority-description">
            {{ dataItem?.name }}
          </span>
        </ng-template>

        <ng-template kendoDropDownListItemTemplate let-dataItem>
          <span
            class="priority-color-circle"
            [style.background-color]="dataItem?.statusColor">
          </span>
          <span class="priority-description">
            {{ dataItem?.name }}
          </span>
        </ng-template>

      </kendo-dropdownlist>

      <kendo-formerror *ngIf="form.controls.priority.invalid">
        Priority is required
      </kendo-formerror>
    </kendo-formfield>

    <kendo-formfield class="form-group form-group--flex">
      <kendo-label text="Issue Type"></kendo-label>
      <kendo-dropdownlist
        [data]="issueType"
        valueField="id"
        textField="name"
        formControlName="issueType">

        <ng-template kendoDropDownListItemTemplate let-dataItem>
          <img [src]="dataItem.iconUrl" alt="" class="issue-icon"/>
          <span>{{ dataItem.name }}</span>
        </ng-template>

        <ng-template kendoDropDownListValueTemplate let-dataItem>
          <img *ngIf="dataItem" [src]="dataItem.iconUrl" alt="" class="issue-icon"/>
          <span>{{ dataItem?.name }}</span>
        </ng-template>

      </kendo-dropdownlist>

      <kendo-formerror *ngIf="form.controls.issueType.invalid">
        Issue type is required
      </kendo-formerror>
    </kendo-formfield>

    <kendo-formfield class="form-group form-group--flex">
      <kendo-label text="Task Type"></kendo-label>
      <kendo-multiselect
        [data]="taskTypes"
        valueField="value"
        textField="displayName"
        formControlName="taskType">
      </kendo-multiselect>

      <kendo-formerror *ngIf="form.controls.taskType.invalid">
        Task type is required
      </kendo-formerror>
    </kendo-formfield>
  </div>

  <div>
    <div>
      <div>
        <div class="subject-container">
          <h3>{{ context.ticket.subject }}</h3>
          <div #anchor>
            <div>
              <svg (click)="showInfoLogs = true;" style="width:25px; cursor: pointer;" viewBox="0 0 512 512">
                <path
                  d="M288 352h32v32H192v-32h32v-96h-32v-32h96v128zm0-224h-64v64h64v-64zm192 128c0 123.7-100.3 224-224 224S32 379.7 32 256 132.3 32 256 32s224 100.3 224 224zm-32 0c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path>
              </svg>
            </div>
          </div>

          <kendo-popup
            [anchor]="anchor"
            (anchorViewportLeave)="showInfoLogs = false"
            *ngIf="showInfoLogs"
            style="width: 500px;">
            <div class="content">
              <h3 class="popover-header">
                <b>{{ 'User Information'|translate }}</b>
                <i class="fas fa-times"
                   (click)="showInfoLogs = false;"
                   style="cursor: pointer; float: right;"
                ></i>
              </h3>
              <div class="popover-body">
                <div class="popover_content col-md-12"
                     style="display: flex; justify-content: space-between; flex-direction: row;">
                  <div class="row">
                    <div class="col-md-12" style="margin-top: 10px;"><b>{{ 'Full Name'|translate }}
                      : </b>{{ context.ticket?.user?.fullName }}
                    </div>
                    <div class="col-md-12" style="margin-top: 10px;"><b>{{ 'E-mail'|translate }}
                      : </b>{{ context.ticket?.user?.email }}
                    </div>
                    <div class="col-md-12" style="margin-top: 10px;"><b>{{ 'Phone Business Mobile'|translate }}
                      : </b>{{ context.ticket?.user?.telNrBusiness }}
                    </div>
                    <div class="col-md-12" style="margin-top: 10px;"><b>{{ 'Telephone Business Landline'|translate }}
                      : </b>{{ context.ticket?.user?.telNrLandline }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </kendo-popup>
        </div>

        <div class="p-1 border rounded rounded-sm">
          <div class="d-flex justify-content-between pt-2 mb-4">
            <strong
              class="comment-author">{{ context.ticket?.user?.name }} {{ context.ticket?.user?.surname }}</strong>
            <time data-datetime="calendar"> {{ context.ticket.created_at | date: 'dd.MM.yyyy HH:mm' }}</time>
          </div>

          <div [innerHTML]="context.ticket.description" class="my-2"></div>

          <div class="d-flex">
            <div>
              <div *ngFor="let f of context.ticket.files" class="col-md-4">
                <img documentAppendToken src="{{context.fileUrl}}/{{f.fileName}}" alt=""
                     (click)="openReplyPhoto(f.fileName)" style="width: 250px; margin-right: 20px;">
              </div>
            </div>
          </div>
        </div>

        <div *ngFor="let item of context.ticketReplies" class="mt-3 p-2 border rounded rounded-sm">
          <div class="d-flex justify-content-between pt-2">
            <strong class="comment-author">{{ item.user }}</strong>
            <time data-datetime="calendar"> {{ item.created_at | date: 'dd.MM.yyyy HH:mm' }}</time>
          </div>
          <div [innerHTML]="item.description" class="ticket-description"></div>
          <div>
            <div>
              <div *ngFor="let f of item.files">
                <img documentAppendToken src="{{context.fileUrl}}/{{f.fileName}}" alt=""
                     (click)="openReplyPhoto(f.fileName)">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-4">
    <kendo-editor formControlName="jiraAdditionalDescription">
      <kendo-toolbar>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
        <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
        <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
        <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
        <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient"></kendo-toolbar-colorpicker>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorBlockquoteButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
        <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorPrintButton></kendo-toolbar-button>
      </kendo-toolbar>
    </kendo-editor>
  </div>

  <div class="upload-file-area">
    <img
      *ngIf="jiraAdditionalAttachment"
      src="{{context.fileUrl}}/{{this.jiraAdditionalAttachment}}"
      alt="image-preview"
    />

    <h6>{{ 'place files here to upload them'|translate }}</h6>

    <ngx-dropzone class="ng-dropzone" [multiple]="false" (change)="onFilesAdded($event)">
      <ngx-dropzone-label><i class="fa fa-upload" aria-hidden="true"></i></ngx-dropzone-label>
    </ngx-dropzone>
  </div>

  <div class="form-actions">
    <kendo-button size="large" [disabled]="isCreating" type="submit" themeColor="tertiary" (click)="onSubmit()">
      <kendo-loader
        *ngIf="isCreating"
        themeColor="light"
        size="medium"
      >
      </kendo-loader>
      {{ isCreating ? 'Creating...' : 'Submit to Jira' }}
    </kendo-button>
  </div>
</form>

<kendo-window title="{{'Photo'|translate}}" *ngIf="replyPhotoOpen" (close)="closeReplyPhoto()" [top]="30">
  <div class="modal-body">
    <img documentAppendToken [src]="photoReplyView" alt="photoReplay">
  </div>
</kendo-window>
